<template>
  <div class="comtainer-main">
      <div class="tag">你的浏览器暂不支持，建议使用支付宝或微信浏览！</div>
  </div>
</template>
<script>
import Vue from 'vue';
import { Toast } from 'vant';
export default {
  name: 'nonsupport',
  components: {
  },
  mounted () {
  },
  created() {
  },
  data () {
    return {
    }
  },
  methods: {
    
  }
}
</script>
<style  scoped>
.comtainer-main{
    width: 100%;
    height: 100%;
    background-color: #eeeeee;
}
.tag{
    padding-top: 30vh;
    margin:0 20px;
    height: 60px;
    line-height: 60px;
    font-size: 30px;
    text-align: center;
    color: #666;
}
</style>